import React from "react";
import "./Guides.css";

const Guides = ({ guidesVisible, position }) => {
  const visible = guidesVisible ? "active" : "",
    styles = {
      width: position.width,
      height: position.height,
    };

  return (
    <div className={`guides ${visible}`} style={styles}>
      <div className="guides__vertical" />
      <div className="guides__horizontal" />
    </div>
  );
};

export default Guides;
